module.exports = __webpack_public_path__ + "static/yeti-d975ab6ac5ab3bcee82ee2e73f85f5fd.png";